export default __webpack_public_path__ + "static/media/CIA-Insurance-Proposal.d77e34a5.pdf";